import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import LandingPage from "./components/LandingPage";
import Education from "./components/Education";
import History from "./components/History";
import PlagiarismDetector from "./components/PlagiarismDetector";
import "./i18n";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<Dashboard />} />
        <Route path="/education" element={<Education />} />
        <Route path="/history" element={<History />} />
        <Route path="/plagiarism" element={<PlagiarismDetector />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
